import type { FC } from "react";
import { WeekViewProvider } from "../../../contexts/WeekView";
import { RequestsTab } from "../../RequestData/RequestsTab/RequestsTab";
import { useIsGapsViewActive } from "./useGapsViewPreference";

/**
 * Which layout `/:departmentId/requests` draws on a phone: the gaps-first view's Open Shifts (P3-12) when that view is
 * what the user is in, else the classic Requests screen, unchanged.
 *
 * A component rather than a fork in the route table for the reason `MobileStaffingRouteSwitch` gives: the choice reads a
 * feature flag and the stored view, and an `element: (ctx) => …` factory runs outside every provider, so it may construct
 * a component but never call a hook. It asks the same `useIsGapsViewActive` that decides whether `Layout` draws the
 * bottom bar, so the bar and this layout can never disagree.
 *
 * The route sits outside the staffing pages' `WeekViewProvider`, but Open Shifts' sheets page through the schedule's
 * weeks as the home does (`useGapsVisibleWeek`), so it gets its own. The classic screen reads none of it, so it doesn't
 * load the shown week.
 */
export const RequestsRouteSwitch: FC = () => {
	const isGapsViewActive = useIsGapsViewActive();
	return isGapsViewActive ? (
		<WeekViewProvider>
			<RequestsTab variant="gaps" />
		</WeekViewProvider>
	) : (
		<RequestsTab />
	);
};
